import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';
import axios from 'axios';

import * as $ from 'jquery';

let cancelToken;
let state;
let tokenSession;

class SummaryDomicilio extends Component {

  getInitState = () => {
    return {
      subtotal: "0",
      currency: "USD",
      credits: "0",
      iva: "0",
      total: "0",
    }
  }

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  componentDidMount() {
    this.reload();
  }

  //
  reload = () => {
    // if (this.props.duracion_id == 1) {
    //   this.setState({
    //     subtotal: this.props.cowork.coworks_precio_day,
    //     iva: this.props.cowork.coworks_precio_day * .16,
    //     total: this.props.cowork.coworks_precio_day * 1.16,
    //   })
    // } else if (this.props.duracion_id == 2) {
    //   this.setState({
    //     subtotal: this.props.cowork.coworks_precio_week,
    //     iva: this.props.cowork.coworks_precio_week * .16,
    //     total: this.props.cowork.coworks_precio_week * 1.16,
    //   })
    // } else if (this.props.duracion_id == 3) {
    //   this.setState({
    //     subtotal: this.props.cowork.coworks_precio_year,
    //     iva: this.props.cowork.coworks_precio_year * .16,
    //     total: this.props.cowork.coworks_precio_year * 1.16,
    //   })
    // }
  }


  render() {
    console.log(this.props);
    const center = this.props.center
    const duracion = this.props.duracion_str
    const start_day = this.props.start_day
    const endDate = this.props.endDate
    const paymentDetails = this.state
    const { t } = this.props;

    return (
      <div className="card-panel panel panel-default card card_cowork">
        <div className="panel-heading-text">
          <h4 className="panel-title">{t('dashboard.room_payment.heading_summary')}</h4>
        </div>
        <div className="panel-heading" style={{ backgroundImage: "url('https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/" + center.id + "')" }}>
        </div>
        <div className="panel-body">
          <div className="contenedor-flexbox">
            <div className="contenedor">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {" "}{center.direccion},{center.ciudad},{center.estado}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar-o" aria-hidden="true"></i>
              {" "}{this.props.duracion_str}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{start_day}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{endDate}
            </div>
            {center.name ? (
              <div className="contenedor">
                <i className="fa fa-building-o" aria-hidden="true"></i>
                {" "}{center.name}
              </div>
            ) : null}
          </div>
        </div>
        <button
          className="btn btn-lg btn-primary btn-singup-help"
          type="button"
          style={{
            marginInline: "0px",
            color: "#000",
            backgroundColor: "#fff",
            border: "2px solid #000",
            height: '45%', width: '100%', borderRadius: '45px'
          }}
          onClick={() => $('#btnSuccessHelp').click()}
        >
          <span>
            <Trans>dashboard.contact.holder_message</Trans>
          </span>
        </button>
      </div>
    );
  }
}

export default translate('common')(SummaryDomicilio);



// WEBPACK FOOTER //
// ./src/store/Payment/SummaryDomicilio.js